"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get ArchiveReopenRoleResponse () {
        return ArchiveReopenRoleResponse;
    },
    get AssignEmployeesResponse () {
        return AssignEmployeesResponse;
    },
    get BulkPatchRoleCompetenciesResponse () {
        return BulkPatchRoleCompetenciesResponse;
    },
    get CheckRoleNameResponse () {
        return CheckRoleNameResponse;
    },
    get ListRoleOptionsResponse () {
        return ListRoleOptionsResponse;
    },
    get ListRolesResponse () {
        return ListRolesResponse;
    },
    get RoleCompetenciesResponse () {
        return RoleCompetenciesResponse;
    },
    get RoleEmployeesResponse () {
        return RoleEmployeesResponse;
    },
    get SingleRoleResponse () {
        return SingleRoleResponse;
    }
});
const _zod = require("zod");
const _responsehelpers = require("../helpers/response-helpers");
const UserActionResponse = _zod.z.object({
    user_id: _responsehelpers.ResponseObjectId,
    time_stamp: _zod.z.union([
        _zod.z.date(),
        _zod.z.string()
    ])
});
const RoleCompetencyEntryResponseSchema = _zod.z.object({
    competency_id: _responsehelpers.ResponseObjectId,
    expected_level: _zod.z.number().int().nullable()
});
const RoleResponseItem = _zod.z.object({
    _id: _responsehelpers.ResponseObjectId,
    company_id: _responsehelpers.ResponseObjectId,
    name: _zod.z.string(),
    description: _zod.z.string(),
    status: _zod.z.enum([
        "active",
        "archived"
    ]),
    competencies: _zod.z.array(RoleCompetencyEntryResponseSchema),
    employeeCount: _zod.z.number().int(),
    created: UserActionResponse,
    updated: UserActionResponse
});
const ListRolesResponse = _zod.z.object({
    roles: _zod.z.array(RoleResponseItem),
    totalCount: _zod.z.number()
});
const RoleOptionResponseItem = _zod.z.object({
    _id: _responsehelpers.ResponseObjectId,
    name: _zod.z.string()
});
const ListRoleOptionsResponse = _zod.z.object({
    roles: _zod.z.array(RoleOptionResponseItem),
    totalCount: _zod.z.number()
});
const SingleRoleResponse = _zod.z.object({
    role: RoleResponseItem,
    /**
	 * True while the company's Role custom field is mapped to an HRIS integration — role
	 * membership is then sync-managed and admin editing surfaces lock.
	 */ roleFieldIntegrationConnected: _zod.z.boolean()
});
const CheckRoleNameResponse = _zod.z.object({
    available: _zod.z.boolean()
});
const ArchiveReopenRoleResponse = _zod.z.object({
    success: _zod.z.boolean()
});
// GET /v1/roles/:id/competencies — joins with competency docs
const RoleCompetencyDetailSchema = _zod.z.object({
    competency_id: _responsehelpers.ResponseObjectId,
    expected_level: _zod.z.number().int().nullable(),
    name: _zod.z.string(),
    description: _zod.z.string(),
    is_company_wide: _zod.z.boolean(),
    levels: _zod.z.array(_zod.z.object({
        rank: _zod.z.number().int(),
        name: _zod.z.string(),
        description: _zod.z.string()
    })),
    status: _zod.z.enum([
        "active",
        "archived"
    ])
});
const RoleCompetenciesResponse = _zod.z.object({
    competencies: _zod.z.array(RoleCompetencyDetailSchema)
});
// GET /v1/roles/:id/employees — joins with user docs
const RoleEmployeeSchema = _zod.z.object({
    user_id: _responsehelpers.ResponseObjectId,
    name: _zod.z.string(),
    group_name: _zod.z.string().nullable(),
    manager_id: _responsehelpers.ResponseObjectId.nullable(),
    manager_name: _zod.z.string().nullable()
});
const RoleEmployeesResponse = _zod.z.object({
    employees: _zod.z.array(RoleEmployeeSchema),
    totalCount: _zod.z.number()
});
const AssignEmployeesResponse = _zod.z.object({
    successful: _zod.z.array(_responsehelpers.ResponseObjectId),
    failed: _zod.z.array(_zod.z.object({
        user_id: _responsehelpers.ResponseObjectId,
        error: _zod.z.string()
    }))
});
const BulkPatchRoleCompetenciesResponse = _zod.z.object({
    successful: _zod.z.array(_responsehelpers.ResponseObjectId),
    failed: _zod.z.array(_zod.z.object({
        competency_id: _responsehelpers.ResponseObjectId,
        error: _zod.z.string()
    }))
});
